import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/themeFour/logo.png'
import _imports_1 from '@/assets/themeFour/caller.png'
import _imports_2 from '@/assets/themeFour/cash.png'
import _imports_3 from '@/assets/themeFour/btn1.png'
import _imports_4 from '@/assets/themeFour/btn2.png'
import _imports_5 from '@/assets/themeThree/POPULAR_on.png'
import _imports_6 from '@/assets/themeFour/l1.png'


const _hoisted_1 = { class: "header_button_item" }
const _hoisted_2 = { class: "coin_btn" }
const _hoisted_3 = { style: {"padding-left":"10px"} }
const _hoisted_4 = { class: "balanceText" }
const _hoisted_5 = {
  key: 0,
  class: "populargamesCard"
}
const _hoisted_6 = { class: "headTitle" }
const _hoisted_7 = { class: "titleText" }
const _hoisted_8 = { class: "balanceText" }
const _hoisted_9 = ["src", "onClick"]
const _hoisted_10 = { class: "icon-wrapper" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "activityName" }
const _hoisted_13 = { class: "groupList" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "share_content" }
const _hoisted_16 = { class: "shareTitle" }
const _hoisted_17 = { style: {"display":"flex"} }
const _hoisted_18 = ["src"]

import { computed, inject, nextTick, ref, } from 'vue'
import { useRouter } from 'vue-router'
import { playClickSound } from '@/utils/media'
import { useI18n } from 'vue-i18n';
import { useActivityStore } from '@/stores/activity'
import { useUserStore } from '@/stores/user'
import PwaAntiBlockingPopup from '../common/pwaAntiBlockingPopup.vue'
import PwaStatusPopup from '../common/pwaStatusPopup.vue'
import { handleMenuClick, SideMenuListItem, goToShare, SHARE_LIST } from '@/view/components/supportFunction'
import { formatCurrency } from '@/utils/commonFunction';
import { useGameStore } from '@/stores/games';
import { goToPlayGame } from '@/view/home/supportScript';

export default /*@__PURE__*/_defineComponent({
  __name: 'sideNavbar',
  props: {
    listGameData: {}
  },
  emits: ['intallPWA', 'openContactPopup', 'goToGamePanelSlide', 'openPWA'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props
const activityStore = useActivityStore()
const userStore = useUserStore()
const gameStore = useGameStore()
const { t } = useI18n();
const show = ref(false)
const router = useRouter()
const menuList = computed<SideMenuListItem[]>(() => activityStore.activityList)
const openRegisterLoginPopup = inject<(type: number) => void>('openRegisterLoginPopup')
const isRotating = ref(false);
const collectPopupRef = ref()
const collectTimeDropPopupRef = ref()
const agentRef = ref()
const emits = __emit
const pwaPopupRef = ref()
const pwaPopupStatusRef = ref()
const componetList = ref(localStorage.getItem('componetList') || '')
const balance = computed(() => userStore.balance)
const shareList = ref(JSON.parse(componetList.value).find((item: any) => item.component_name == "shareMedia").shareMediaList)
const canRecievedRewards = computed(() => userStore?.PWAConvertData?.canReceiveReward)
const isOpen = computed(() => userStore?.PWAConvertData?.config?.isOpen)
const hotGames = computed(() => gameStore.hotGames)
const gameScrollRef = ref<HTMLElement | null>(null);
const goToGamePannel = (data: any) => {
   show.value = false
   emits('goToGamePanelSlide', data)
}
const openContactPopup = () => {
   emits('openContactPopup')
}
const openRegisterPopup = (type: number) => {
   openRegisterLoginPopup?.(type)
}
const sidebarRef = ref<any>(null);

const resetScroll = () => {
   if (sidebarRef.value?.$el) {
      sidebarRef.value.$el.scrollTop = 0;
   }

   const popupEl = document.querySelector('.van-popup--left');
   if (popupEl) {
      popupEl.scrollTop = 0;
   }
};
const openSidebar = async () => {
   show.value = true
   await nextTick();

   if (gameScrollRef.value) {
      gameScrollRef.value.scrollLeft = 0;
   }
}

const closeSidebar = () => {
   if (isRotating.value) return;
   isRotating.value = true;

   setTimeout(() => {
      show.value = false;
   }, 200);

   setTimeout(() => {
      isRotating.value = false;
   }, 1000);
}

const menuClick = (name: any) => {
   if(name === 'pwa_reward'){
      emits('openPWA')    
   }
   handleMenuClick(name, router, agentRef, collectPopupRef, collectTimeDropPopupRef,
      pwaPopupRef, pwaPopupStatusRef, show, canRecievedRewards.value, isOpen.value, t
   )
}
const GoToPlayGame = (id: any, makerId: any, favorite: number, favId: any) => {
   goToPlayGame(router, openRegisterLoginPopup, id, makerId, favorite, favId)
}
const onButtonClick = () => {
   router.push({ path: '/sd-topup' });
   localStorage.setItem('showDepositBackIcon', '1')
}
__expose({
   openSidebar,
   closeSidebar
})


return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((show).value = $event)),
    onClickOverlay: _cache[8] || (_cache[8] = () => _unref(playClickSound)()),
    position: "left",
    onOpened: resetScroll,
    ref_key: "sidebarRef",
    ref: sidebarRef,
    style: { minHeight: '100%', width: '70%', zIndex: '10002', padding: '0px 0px' }
  }, {
    default: _withCtx(() => [
      _createVNode(_component_van_row, {
        class: "navBar",
        justify: "space-around"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, {
            span: "3",
            onClick: closeSidebar,
            class: "header_item_menu"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_icon, {
                name: "cross",
                color: "#fff",
                size: "15"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "17",
            class: "header_item_logo"
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              }, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "2",
            class: "header_item_menu"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _imports_1,
                alt: "",
                width: "90%",
                style: {"padding-right":"10px"},
                onClick: openContactPopup
              })
            ]),
            _: 1
          }),
          (_unref(userStore).loginAccount)
            ? (_openBlock(), _createBlock(_component_van_col, {
                key: 0,
                style: {"display":"flex","padding-top":"15px"},
                span: "14",
                align: "left"
              }, {
                default: _withCtx(() => [
                  _cache[11] || (_cache[11] = _createElementVNode("img", {
                    src: _imports_2,
                    alt: "",
                    width: "30%"
                  }, null, -1)),
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _cache[10] || (_cache[10] = _createElementVNode("span", { style: {} }, "R$ ", -1)),
                        _createTextVNode(_toDisplayString(_unref(formatCurrency)(balance.value)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('home.balance')), 1)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(userStore).loginAccount)
            ? (_openBlock(), _createBlock(_component_van_col, {
                key: 1,
                span: "8",
                class: "btnContainer"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _imports_3,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (onButtonClick())),
                    alt: "",
                    width: "100%"
                  }),
                  _createElementVNode("div", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (onButtonClick())),
                    class: "depositBtn"
                  }, _toDisplayString(_ctx.$t('common.deposite')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_unref(userStore).loginAccount)
            ? (_openBlock(), _createBlock(_component_van_col, {
                key: 2,
                span: "24",
                class: "header_button_item",
                align: "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_row, { style: {"width":"80%","padding":"15px 10%"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_col, {
                        span: "11",
                        class: "btnContainer"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (openRegisterPopup(1))),
                            src: _imports_4,
                            alt: "",
                            width: "100%",
                            height: "100%"
                          }),
                          _createElementVNode("div", {
                            class: "depositBtn",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (openRegisterPopup(1)))
                          }, _toDisplayString(_ctx.$t('common.login')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_col, {
                        span: "12",
                        offset: "1",
                        class: "btnContainer"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (openRegisterPopup(0))),
                            src: _imports_3,
                            alt: "",
                            height: "100%",
                            width: "100%"
                          }),
                          _createElementVNode("div", {
                            class: "depositBtn",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (openRegisterPopup(0)))
                          }, _toDisplayString(_ctx.$t('common.register')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_unref(gameStore).hotGames && _unref(gameStore).hotGames?.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[12] || (_cache[12] = _createElementVNode("img", {
                src: _imports_5,
                alt: "",
                width: "15%",
                height: "100%"
              }, null, -1)),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('games.popular')), 1)
            ]),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('home.selectionGame')), 1),
            _createElementVNode("div", {
              class: "gameContainer",
              ref_key: "gameScrollRef",
              ref: gameScrollRef
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hotGames.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "gameCard"
                }, [
                  _createElementVNode("img", {
                    src: item.customIcon,
                    alt: "",
                    width: "25%",
                    onClick: ($event: any) => (GoToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite, item.id))
                  }, null, 8, _hoisted_9)
                ]))
              }), 128))
            ], 512)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createVNode(_component_van_row, {
          class: "activity_list",
          align: "center"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_van_col, {
                span: "11",
                key: index,
                onClick: ($event: any) => (menuClick(item.name)),
                class: "activityRow"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[13] || (_cache[13] = _createElementVNode("img", {
                      src: _imports_6,
                      alt: "",
                      width: "40"
                    }, null, -1)),
                    _createElementVNode("img", {
                      class: "icon-Image",
                      src: item.activity_icon,
                      alt: ""
                    }, null, 8, _hoisted_11)
                  ]),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)(`activityName.${item.name}`)), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.listGameData, (item) => {
          return (_openBlock(), _createBlock(_component_van_row, {
            class: "game_list",
            key: item.id,
            onClick: ($event: any) => (goToGamePannel(item)),
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "4",
                class: "game_img_col"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "game_icon",
                    src: item.customIcon,
                    alt: ""
                  }, null, 8, _hoisted_14)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_van_col, {
                span: "20",
                class: "game_img_col"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t(item.name)), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('message.support')) + " Online.", 1),
        _createElementVNode("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shareList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "share_item",
              key: index
            }, [
              (item.display)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: item.url,
                    alt: "",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(goToShare) && _unref(goToShare)(...args)))
                  }, null, 8, _hoisted_18))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})